import { IApplicationState } from '../../types/redux';

export const getBuilderChatPopupParams = (state: IApplicationState) => {
  return {
    defaultMessage: state.builderChat.defaultMessage,
    builderRealtyUserId: state.builderChat.builderRealtyUserId,
    gaLabel: state.builderChat.gaLabel,
  };
};
